import { useState } from 'react'
import { CirclePause, LogOut } from 'lucide-react'
import { useAuth } from '../../auth'
import { MOCK } from '../../api'
import { BillingPage } from './BillingPage'

/**
 * A suspended company (OP-07): sending, the AI and tasks are paused, and the console is closed except for
 * billing, which admins can still use to put things right. Incoming messages are still received and kept.
 */
export function SuspendedPage() {
  const { me, block, signOut } = useAuth()
  const admin = me?.staff.role === 'admin'
  const [billing, setBilling] = useState(false)
  return (
    <div className="h-full flex flex-col bg-bg">
      <div className="shrink-0 bg-red-50 border-b border-red-200 text-red-900 px-5 max-md:px-4 py-3 flex items-start gap-3">
        <CirclePause size={20} className="shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="font-bold">{me?.company.name ?? 'This account'} is suspended</div>
          <div className="text-[12.5px]">
            {block?.message || 'Replies, journeys and tasks are paused. Customer messages are still received and kept, and nothing is lost.'}{' '}
            {admin ? 'If this is about a payment, update your card below; the account comes back as soon as the invoice is paid.' : 'Your admin has been told. They can restore it from Billing, or contact takeit4me.'}
          </div>
        </div>
        <div className="flex gap-2 shrink-0">
          {admin && !billing && <button className="btn sm pri" onClick={() => setBilling(true)}>Open billing</button>}
          {!MOCK && <button className="btn sm" onClick={() => void signOut()}><LogOut /> Sign out</button>}
        </div>
      </div>
      {admin && billing ? <BillingPage /> : (
        <div className="flex-1 flex items-center justify-center text-muted text-[12.5px] px-6 text-center">
          {admin ? 'Open billing to see what is owed and update the payment method.' : 'Nothing to do here until the account is restored.'}
        </div>
      )}
    </div>
  )
}
